import ServicePageTemplate from "../../components/ServicePageTemplate";
import { IMAGES } from "../../lib/assets";

// NOTE TO MIGUEL / CONTENT EDITOR:
// Every value wrapped in [SQUARE BRACKETS] is placeholder copy. Replace with
// final copy, keeping keywords natural. Do not delete the brackets from this
// comment — only from the actual strings below.

export default function FlooringPage() {
  return (
    <ServicePageTemplate
      seo={{
        slug: "flooring",
        // SEO TITLE — under 60 characters preferred
        title:
          "Professional Flooring Installation Auckland & Christchurch | Trust Flooring & Interiors",
        // META DESCRIPTION — 150–160 characters, include primary keywords
        description:
          "Residential and commercial flooring installation across Auckland, Christchurch and New Zealand — engineered timber, laminate, vinyl, LVT and carpet by Trust Flooring & Interiors.",
        canonical: "https://trustflooring.co.nz/services/flooring",
      }}
      eyebrow="Services — Flooring"
      h1="Flooring installation for residential and commercial builds."
      // [INSERT HERO IMAGE — wide flooring project photograph, ideally an
      // engineered timber or LVT install in an architectural interior]
      heroImage={IMAGES.flooringDetail}
      // [INSERT IMAGE ALT TEXT — keyword rich, e.g. "engineered timber
      // flooring installation in Auckland residential interior"]
      heroAlt="Engineered timber flooring installation in an architectural residential interior, Auckland"
      intro={[
        // [INSERT INTRO PARAGRAPH 1 — include keywords: flooring installation
        // Auckland, commercial flooring New Zealand, engineered timber flooring]
        "Trust Flooring & Interiors delivers precision flooring installation across Auckland, Christchurch and the wider New Zealand market. From engineered timber and solid hardwood through to laminate, LVT, sheet vinyl and carpet, our team works alongside builders, developers and designers to install floors that last — on both residential and commercial projects.",
        // [INSERT INTRO PARAGRAPH 2 — secondary keywords: floor preparation,
        // subfloor levelling, commercial fit-out flooring NZ]
        "Every floor starts with the subfloor. We handle moisture testing, levelling and preparation before installation, so the finished surface reads clean, quiet underfoot and true to the architect's specification. [Replace this paragraph with a sentence about recent flooring projects or certifications if relevant.]",
      ]}
      offerings={{
        heading: "Flooring services we offer.",
        items: [
          "Engineered timber flooring",
          "Solid timber flooring",
          "Laminate flooring",
          "LVT (Luxury Vinyl Tile)",
          "Sheet vinyl",
          "Carpet installation",
          "Carpet tiles",
          "Floor preparation and levelling",
        ],
      }}
      why={{
        heading: "Why specify Trust Flooring.",
        // [INSERT WHY PARAGRAPH — 1–2 sentences, tie to builder/developer value]
        paragraph:
          "Our flooring crews work to tight build programmes without compromising the finish. We coordinate directly with site managers, measure on site and install to manufacturer specification — so handover happens on time and without rework.",
        points: [
          "Experienced installers across timber, resilient and soft flooring",
          "Moisture testing and subfloor preparation in-house",
          "Clean, programme-aware site conduct",
          "One point of contact from quote through to handover",
        ],
      }}
    />
  );
}
